<div class="row g-0">
  <div class="col-12 col-lg-8">
    <div class="card-body">
      <form (ngSubmit)="save()" [formGroup]="form" novalidate>

        <div class="form-group row">
          <label class="col-12 col-lg-6 col-form-label">Weighted Average Cost of Capital (WACC)</label>
          <div class="col-12 col-lg-6">
            <div class="input-group mb-3">
              <input [ngClass]="getFormGroupErrorClasses(form.controls.cost_of_capital)"
                aria-describedby="cost_of_capital" class="form-control" formControlName="cost_of_capital">
              <div class="input-group-text">%</div>
              <div *ngIf="showErrorBlock(form.controls.cost_of_capital)" class="invalid-feedback">
                <p *ngIf="form.controls.cost_of_capital.errors">WACC field is invalid</p>
              </div>
            </div>
            <small class="form-text text-muted">This number will effect the
              <strong>comparative cost of payment terms</strong> on the bid analysis page.
            </small>
          </div>
        </div>

        <div class="form-group row mb-3">
          <label class="col-12 col-lg-6 col-form-label pt-0">Hide Invalid Bids</label>
          <div class="col-12 col-lg-6">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" id="hide_invalid_bids" formControlName="hide_invalid_bids">
              <label class="form-check-label" for="hide_invalid_bids">
                Automatically hide bids with invalid status (Expired, Withdrawn, etc.)
              </label>
            </div>
          </div>
        </div>

        <jft-submit-button *ngIf="user.canManageAdvanced()" (onClick)="save()" [class]="'btn btn-light mb-2'" [disabled]="form.invalid || loading"
          [loadingTitle]="'Saving'" [loading]="form.disabled" [ngbPopover]="getFirstFormGroupErrorLabel(form)"
          [title]="'Save'" placement="left" placement="right" triggers="mouseenter:mouseleave"
          triggers="mouseenter:mouseleave">
        </jft-submit-button>
      </form>

    </div>
  </div>
  <div class="col-12 col-lg-4 bg-light border-start">
    <h3 class="card-header bg-light d-flex align-items-center min-height">
      <span class="fa-stack small me-1">
        <i class="fas fa-square fa-stack-2x"></i>
        <i class="fas fa-info fa-stack-1x fa-inverse"></i>
      </span> How It Works
    </h3>
    <div class="card-body">
      <p>WACC is calculated based on the WACC %, payment terms and total price of each offer.</p>
      <p class="mb-2">WACC Formula:</p>
      <div class="card">
        <div class="card-body small">
          (WACC % / 365) X Payment Terms X Total Price X -1
        </div>
      </div>
    </div>
  </div>
</div>
